import { registerJSONResolver } from '../../registry/jsonResolvers';
import { registerDashboard, createDashboardFromJSON, } from '../../dashboard/registryCore';
import '../../dashboard/definitions';
export var dashboardPlugin = {
    name: 'lightdraw-dashboard',
    version: '1.2.1',
    install: function (LD) {
        registerJSONResolver(function (type, props, app) { return createDashboardFromJSON(type, props, app); });
        LD.registerDashboard =
            registerDashboard;
    },
};
export { registerDashboard, createDashboardFromJSON };
export { animateLiveValue, setLiveValue, dashboardToJSON } from '../../dashboard/helpers';
export { updateChartProps, pushChartValue, pushChartOhlc } from '../../dashboard/charts/core/refresh';
export { installChartResizeObserver, detachChartResizeObserver, } from '../../dashboard/charts/core/responsive';
export { DASHBOARD, resolveDashboardTheme, getActiveDashboard, getDashboardTheme, syncActiveDashboardTheme, runWithDashboardTheme, refreshDashboard, } from '../../dashboard/theme';
export { resolveValueColor, resolveSemanticColor, readColorStops, readDialZones, normalizeDialZones, } from '../../dashboard/colorStops';
export default dashboardPlugin;
